import { useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { Col, Row, Spinner, Table } from 'react-bootstrap';
import { exposedApi, get } from '../../../services/apiController';
import { toast, ToastContainer } from 'react-toastify';
import moment from 'moment';

const PmDcView = () => {
  let params = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState();

  const getDeliveryChallan = () => {
    try {
      setIsLoading(true);
      exposedApi(`/exposed/inv/pm-production-indent/delivery-challan/${params.id}`)
        .then((res) => {
          setData(res.data);
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
          console.log('err', err);
        });
    } catch (error) {
      setIsLoading(false);
      toast.error(error?.response?.data?.data?.message || 'Something went wrong');
    }
  };

  useEffect(() => {
    getDeliveryChallan();
  }, [params?.id]);

  const [hsnSummary, setHsnSummary] = useState([]);

  useEffect(() => {
    // Group items by HSN code
    const hsnGroups = {};
    data?.ProductionIndentDetails?.forEach((item) => {
      if (!hsnGroups[item.Item.hsnCode]) {
        hsnGroups[item.Item.hsnCode] = {
          quantity: 0,
          taxableAmount: 0,
          hsnDesc: item?.Item?.hsnDesc,
          uom: item?.Item?.unit,
          gst: item.gst,
        };
      }
      hsnGroups[item.Item.hsnCode].quantity += item.issuedQuantity;
      hsnGroups[item.Item.hsnCode].taxableAmount += item.issuedQuantity * item.rate;
    });

    // Convert the grouped data into an array
    const summaryArray = Object.keys(hsnGroups).map((hsnCode) => ({
      hsnCode,
      ...hsnGroups[hsnCode],
    }));

    setHsnSummary(summaryArray);
  }, [data]);

  let totalQuantity = 0;
  let totalTaxableAmount = 0;
  let totalGST = 0;

  let dcNumber = data?.dcNumber;
  if (dcNumber && !dcNumber.includes('/2024/116')) {
    const parts = dcNumber.split('/');
    dcNumber = 'MRSGWN/' + parts[2] + (parts.includes('JW') ? '/' + parts[3] : '');
  }

  return (
    <>
      <ToastContainer />
      {isLoading ? (
        <Spinner animation="border" variant="info" />
      ) : (
        <div className="grn-detail print-view me-5 ms-5">
          <div className=" text-center mb-3">
            <h6 className="m-0 mb-1">DELIVERY CHALLAN {data?.isPackagingKitchen && '(JOB WORK)'}</h6>
            <h6 className="m-0 mb-2">KANTI SWEETS PRIVATE LIMITED</h6>
            <h6 className="m-0" style={{ fontSize: '11px' }}>
              14, Chennakrishnappa Street, 4th Main Rd, Palace Guttahalli,
              <br />
              Bengaluru, Karnataka 560003 <br /> GSTIN: 29AAICK2351H1ZG
            </h6>
          </div>
          <Row className="mb-2">
            <Col xs={5}>
              <h6 className="m-0" style={{ fontSize: '11px' }}>
                From: <br />
                KANTI SWEETS PRIVATE LIMITED - {data?.Branch?.name}
                <br />
                {data?.Branch?.address}
              </h6>
            </Col>
            <Col xs={2}></Col>
            <Col xs={5}>
              <h6 className="m-0" style={{ fontSize: '11px' }}>
                To:
                <br />
                {data?.isPackagingKitchen ? data?.Kitchen?.name : `KANTI SWEETS PRIVATE LIMITED - ${data?.Kitchen?.name}`}
                <br />
                {data?.Kitchen?.address ?? data?.address}
              </h6>
            </Col>
          </Row>
          <Table bordered className="text-center delivery-challan-table mt-2 mb-3">
            <thead>
              <tr>
                <th colSpan={data?.isPackagingKitchen ? 11 : 7}>
                  <Row>
                    <Col xs={4}>
                      <h6 style={{ fontSize: '11px' }}>DC No: {dcNumber}</h6>
                    </Col>
                    <Col xs={4}>
                      {data?.eWayBillNumber && (
                        <h6 style={{ fontSize: '11px', textAlign: 'center' }}>E-Way Bill No: {data?.eWayBillNumber}</h6>
                      )}
                    </Col>
                    <Col xs={4}>
                      <h6 style={{ fontSize: '11px', textAlign: 'right' }}>
                        DC Date: {moment(data?.productionIndentDate).format('DD/MM/YYYY')}
                      </h6>
                    </Col>
                  </Row>
                </th>
              </tr>
              <tr style={{ fontSize: '11px' }}>
                <th style={{ width: '10px' }}>S.No.</th>
                <th style={{ width: '400px' }}>Item Name</th>
                <th>HSN Code</th>
                {data?.isPackagingKitchen && <th>GST Rate %</th>}
                <th>Quantity</th>
                <th>UoM</th>
                <th>Rate Per Unit</th>
                {data?.isPackagingKitchen && (
                  <>
                    <th>Taxable Value</th>
                    <th>CGST</th>
                    <th>SGST</th>
                  </>
                )}
                <th>Amount</th>
              </tr>
            </thead>
            <tbody style={{ fontSize: '10px' }}>
              {data?.ProductionIndentDetails?.map((item, index) => {
                const itemAmount = item.issuedQuantity * item?.rate;
                totalTaxableAmount += itemAmount;
                totalGST += (itemAmount * item?.gst) / 100;
                totalQuantity += item.issuedQuantity;
                return (
                  <tr key={index} style={{ borderBottom: 'hidden' }}>
                    <th>{index + 1}</th>
                    <th>{item?.Item?.name}</th>
                    <th>{item?.Item?.hsnCode}</th>
                    {data?.isPackagingKitchen && <th>{item?.gst ?? 0} %</th>}
                    <th>{item?.issuedQuantity}</th>
                    <th>{item?.Item?.unit}</th>
                    <th>{item?.rate}</th>
                    {data?.isPackagingKitchen && (
                      <>
                        <th>{itemAmount.toFixed(2)}</th>
                        <th>{((itemAmount * (item?.gst ?? 0)) / 200).toFixed(2)}</th>
                        <th>{((itemAmount * (item?.gst ?? 0)) / 200).toFixed(2)}</th>
                      </>
                    )}
                    <th>
                      {data?.isPackagingKitchen ? (itemAmount + (itemAmount * (item?.gst ?? 0)) / 100).toFixed(2) : itemAmount.toFixed(2)}
                    </th>
                  </tr>
                );
              })}
              <tr></tr>
              <tr>
                <th className="text-center" colSpan={data?.isPackagingKitchen ? 4 : 3}>
                  Total Quantity
                </th>
                <th>{totalQuantity}</th>
                <th className="text-center" colSpan={2}>
                  Total Amount
                </th>

                {data?.isPackagingKitchen && (
                  <>
                    <th>{totalTaxableAmount.toFixed(2)}</th>
                    <th>{(totalGST / 2).toFixed(2)}</th>
                    <th>{(totalGST / 2).toFixed(2)}</th>
                  </>
                )}
                <th>{data?.isPackagingKitchen ? `${(totalTaxableAmount + totalGST).toFixed(2)}` : `${totalTaxableAmount.toFixed(2)}`}</th>
              </tr>
            </tbody>
          </Table>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <h6 style={{ fontSize: '11px' }}>Vehicle No.:</h6>
            <h6 style={{ fontSize: '11px', margin: '0px 20px 0px 20px', width: '100px' }}>{data?.vehicleNumber}</h6>
            {!data?.isPackagingKitchen && <h6 style={{ fontSize: '11px' }}>OWN VEHICLE</h6>}
          </div>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Table bordered className="text-center delivery-challan-table mt-2 mb-3">
              <thead>
                <tr style={{ fontSize: '11px' }}>
                  <th>HSN Code</th>
                  <th>HSN Description</th>
                  {data?.isPackagingKitchen ? (
                    <th>Qty issued to JW</th>
                  ) : (
                    <th>Quantity</th>
                  )}
                  <th>UoM</th>
                  <th>Taxable Amt</th>
                  {data?.isPackagingKitchen ? (
                    <>
                      <th>CGST%</th>
                      <th>SGST%</th>
                    </>
                  ) : (
                    <th>GST%</th>
                  )}
                </tr>
              </thead>
              <tbody style={{ fontSize: '10px' }}>
                {hsnSummary.map((summary, index) => (
                  <tr key={index} style={{ borderBottom: 'hidden' }}>
                    <th>{summary?.hsnCode}</th>
                    <th>{summary?.hsnDesc}</th>
                    <th>{summary?.quantity}</th>
                    <th>{summary?.uom}</th>
                    <th>{summary?.taxableAmount.toFixed(2)}</th>
                    {data?.isPackagingKitchen ? (
                      <>
                        <th>{summary?.gst.toFixed(2) / 2}</th>
                        <th>{summary?.gst.toFixed(2) / 2}</th>
                      </>
                    ) : (
                      <th>{summary?.gst.toFixed(2)}</th>
                    )}
                  </tr>
                ))}
                <tr></tr>
              </tbody>
            </Table>
          </div>
          <div className="mt-3">
            <h6 style={{ fontSize: '11px' }}>PURPOSE OF TRANSPORTATION</h6>
            <h6 style={{ fontSize: '11px' }}>
              STOCK TRANSFER {data?.isPackagingKitchen ? 'FOR JOB WORK (NOT FOR SALE)' : ' TO SHOP/BRANCH/HEAD OFFICE/GODOWN.'}
            </h6>
          </div>
          <Table style={{ width: '100%', marginTop: '20px' }}>
            {data?.isPackagingKitchen ? (
              <tr>
                <th className="text-center" style={{ fontSize: '11px' }} width="50%" align="left">
                  Prepared By
                </th>
                <th className="text-center" style={{ fontSize: '11px' }} width="50%" align="right">
                  Checked & Received By
                </th>
              </tr>
            ) : (
              <tr>
                <th className="text-center" style={{ fontSize: '11px' }} width="33.33%" align="left">
                  Prepared By
                  <br />
                  Factory
                  <br />
                </th>
                <th className="text-center" style={{ fontSize: '11px' }} width="33.33%" align="center">
                  Checked By
                  <br />
                  Factory
                  <br />
                </th>
                <th className="text-center" style={{ fontSize: '11px' }} width="33.33%" align="right">
                  Checked & Received By
                  <br />
                  Shop
                  <br />
                </th>
              </tr>
            )}
          </Table>
        </div>
      )}
    </>
  );
};

export default PmDcView;
